import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';

import { AccountClientHistory } from './clientHistory';
import { AccountDetailGeneralInfo } from './generalInfo';
import { AccountHabeasDataHistory } from './habeasDataHistory';
import { AccountRegisterHistory } from './registerHistory';
import { useAccountDetail } from './hook';
import { AccountHistorical } from '../historical';

import { AccountRegisterCasePqr } from './casePqr';
import { AccountRegisterCaseSarlaft } from './caseSarlaft';
import { AccountRegisterCasesGeneralInformationForm } from './casesGeneralInformationForm';
import { AccountRegisterCaseGeneral } from './caseGeneral';

import { LayoutModule } from '../../../../layout/modules';
import { TitleV1 } from '../../../../components/titleV1';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    isSupervisor,
    isTrainerOrQuality,
} from '../../../../../shared/types/profiles';

import {
    ACCOUNTS,
    ACCOUNTS_NEW,
    ACCOUNTS_EDIT,
} from '../../../../../routes/paths';

export const AccountDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const { account, loading, accountHistorical } =
        useAccountDetail(showHistorical);
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = account && account?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle cuenta"
                titleChildren="INFORMACIÓN GENERAL - PERSONA DE CONTACTO"
                additionalButtons={
                    <ActionButtonGroup
                        id={account?.id || ''}
                        buttonCreate={{
                            show:
                                showActionButtons && !isTrainerOrQuality(type),
                            route: ACCOUNTS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: ACCOUNTS,
                        }}
                        buttonUpdate={{
                            show: !isTrainerOrQuality(type),
                            route: ACCOUNTS_EDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <AccountHistorical
                            historical={accountHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <AccountDetailGeneralInfo account={account} loading={loading} />
            </LayoutModule>
            <AccountHabeasDataHistory />
            <AccountClientHistory />
            <AccountRegisterHistory account={account} />
            {!isTrainerOrQuality(type) && (
                <>
                    <TitleV1 title="REGISTRO DE CASOS" />
                    {!isSupervisor(type) && (
                        <AccountRegisterCasesGeneralInformationForm />
                    )}
                    <AccountRegisterCasePqr />
                    {!isSupervisor(type) && (
                        <>
                            <AccountRegisterCaseSarlaft account={account} />
                            <AccountRegisterCaseGeneral />
                        </>
                    )}
                </>
            )}
        </>
    );
};
